(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequired6e5"];
var parcelRegister = parcelRequire.register;
parcelRegister("dt2kA", function(module, exports) {

$parcel$export(module.exports, "Splide", function () { return (parcelRequire("hC3pE")).default; });
$parcel$export(module.exports, "AutoScroll", function () { return (parcelRequire("gPLEK")).AutoScroll; });

var $hC3pE = parcelRequire("hC3pE");

var $gPLEK = parcelRequire("gPLEK");

});
parcelRegister("gPLEK", function(module, exports) {

$parcel$export(module.exports, "AutoScroll", function () { return $c416604b0ac15a13$export$3fb39aee5567f02e; });
/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ 
var $kccop = parcelRequire("kccop");

var $dvYFb = parcelRequire("dvYFb");
function $c416604b0ac15a13$var$empty(array) {
    array.length = 0;
}
function $c416604b0ac15a13$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $c416604b0ac15a13$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($c416604b0ac15a13$var$slice$1(arguments, 1)));
}
function $c416604b0ac15a13$var$raf(func) {
    return requestAnimationFrame(func);
}
function $c416604b0ac15a13$var$typeOf$1(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $dvYFb._)(subject)) === type;
}
var $c416604b0ac15a13$var$isArray$1 = Array.isArray;
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "function");
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "string");
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "undefined");
function $c416604b0ac15a13$var$toArray$1(value) {
    return $c416604b0ac15a13$var$isArray$1(value) ? value : [
        value
    ];
}
function $c416604b0ac15a13$var$forEach$1(values, iteratee) {
    $c416604b0ac15a13$var$toArray$1(values).forEach(iteratee);
}
var $c416604b0ac15a13$var$ownKeys$1 = Object.keys;
function $c416604b0ac15a13$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $c416604b0ac15a13$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $c416604b0ac15a13$var$assign$1(object) {
    $c416604b0ac15a13$var$slice$1(arguments, 1).forEach(function(source) {
        $c416604b0ac15a13$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $c416604b0ac15a13$var$min$1 = Math.min;
function $c416604b0ac15a13$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $c416604b0ac15a13$var$forEach$1(targets, function(target) {
            target && $c416604b0ac15a13$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $c416604b0ac15a13$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $c416604b0ac15a13$var$EVENT_MOVE = "move";
var $c416604b0ac15a13$var$EVENT_MOVED = "moved";
var $c416604b0ac15a13$var$EVENT_UPDATED = "updated";
var $c416604b0ac15a13$var$EVENT_DRAG = "drag";
var $c416604b0ac15a13$var$EVENT_DRAGGED = "dragged";
var $c416604b0ac15a13$var$EVENT_SCROLL = "scroll";
var $c416604b0ac15a13$var$EVENT_SCROLLED = "scrolled";
var $c416604b0ac15a13$var$EVENT_DESTROY = "destroy";
function $c416604b0ac15a13$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $c416604b0ac15a13$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $c416604b0ac15a13$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $c416604b0ac15a13$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $c416604b0ac15a13$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($c416604b0ac15a13$var$EVENT_DESTROY, binder.destroy);
    return $c416604b0ac15a13$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $c416604b0ac15a13$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
function $c416604b0ac15a13$var$RequestInterval(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $c416604b0ac15a13$var$min$1((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            $c416604b0ac15a13$var$raf(update);
        }
    }
    function start(resume) {
        !resume && cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        $c416604b0ac15a13$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $c416604b0ac15a13$var$Throttle(func, duration) {
    var interval;
    function throttled() {
        if (!interval) {
            interval = $c416604b0ac15a13$var$RequestInterval(duration || 0, function() {
                func();
                interval = null;
            }, null, 1);
            interval.start();
        }
    }
    return throttled;
}
var $c416604b0ac15a13$var$CLASS_ACTIVE = "is-active";
var $c416604b0ac15a13$var$SLIDE = "slide";
var $c416604b0ac15a13$var$FADE = "fade";
function $c416604b0ac15a13$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $c416604b0ac15a13$var$apply(func) {
    var _func;
    return (_func = func).bind.apply(_func, [
        null
    ].concat((0, $kccop._)($c416604b0ac15a13$var$slice(arguments, 1))));
}
function $c416604b0ac15a13$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $dvYFb._)(subject)) === type;
}
function $c416604b0ac15a13$var$isObject(subject) {
    return !$c416604b0ac15a13$var$isNull(subject) && $c416604b0ac15a13$var$typeOf("object", subject);
}
var $c416604b0ac15a13$var$isArray = Array.isArray;
$c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "function");
$c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "string");
var $c416604b0ac15a13$var$isUndefined = $c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "undefined");
function $c416604b0ac15a13$var$isNull(subject) {
    return subject === null;
}
function $c416604b0ac15a13$var$toArray(value) {
    return $c416604b0ac15a13$var$isArray(value) ? value : [
        value
    ];
}
function $c416604b0ac15a13$var$forEach(values, iteratee) {
    $c416604b0ac15a13$var$toArray(values).forEach(iteratee);
}
function $c416604b0ac15a13$var$toggleClass(elm, classes, add) {
    if (elm) $c416604b0ac15a13$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
var $c416604b0ac15a13$var$ownKeys = Object.keys;
function $c416604b0ac15a13$var$forOwn(object, iteratee, right) {
    if (object) {
        var keys = $c416604b0ac15a13$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $c416604b0ac15a13$var$assign(object) {
    $c416604b0ac15a13$var$slice(arguments, 1).forEach(function(source) {
        $c416604b0ac15a13$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $c416604b0ac15a13$var$removeAttribute(elms, attrs) {
    $c416604b0ac15a13$var$forEach(elms, function(elm) {
        $c416604b0ac15a13$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $c416604b0ac15a13$var$setAttribute(elms, attrs, value) {
    if ($c416604b0ac15a13$var$isObject(attrs)) $c416604b0ac15a13$var$forOwn(attrs, function(value2, name) {
        $c416604b0ac15a13$var$setAttribute(elms, name, value2);
    });
    else $c416604b0ac15a13$var$forEach(elms, function(elm) {
        $c416604b0ac15a13$var$isNull(value) || value === "" ? $c416604b0ac15a13$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
var $c416604b0ac15a13$var$min = Math.min, $c416604b0ac15a13$var$max = Math.max, $c416604b0ac15a13$var$floor = Math.floor, $c416604b0ac15a13$var$ceil = Math.ceil, $c416604b0ac15a13$var$abs = Math.abs;
function $c416604b0ac15a13$var$clamp(number, x, y) {
    var minimum = $c416604b0ac15a13$var$min(x, y);
    var maximum = $c416604b0ac15a13$var$max(x, y);
    return $c416604b0ac15a13$var$min($c416604b0ac15a13$var$max(minimum, number), maximum);
}
var $c416604b0ac15a13$var$DEFAULTS = {
    speed: 1,
    autoStart: true,
    pauseOnHover: true,
    pauseOnFocus: true
};
var $c416604b0ac15a13$var$I18N = {
    startScroll: "Start auto scroll",
    pauseScroll: "Pause auto scroll"
};
function $c416604b0ac15a13$export$3fb39aee5567f02e(Splide2, Components2, options) {
    var _EventInterface = $c416604b0ac15a13$var$EventInterface(Splide2), on = _EventInterface.on, off = _EventInterface.off, bind = _EventInterface.bind, unbind = _EventInterface.unbind;
    var _Components2_Move = Components2.Move, translate = _Components2_Move.translate, getPosition = _Components2_Move.getPosition, toIndex = _Components2_Move.toIndex, getLimit = _Components2_Move.getLimit;
    var _Components2_Controller = Components2.Controller, setIndex = _Components2_Controller.setIndex, getIndex = _Components2_Controller.getIndex;
    var orient = Components2.Direction.orient;
    var toggle = Components2.Elements.toggle;
    var Live = Components2.Live;
    var root = Splide2.root;
    var throttledUpdateArrows = $c416604b0ac15a13$var$Throttle(Components2.Arrows.update, 500);
    var autoScrollOptions = {};
    var interval;
    var stopped;
    var hovered;
    var focused;
    var busy;
    var currPosition;
    function setup() {
        var autoScroll = options.autoScroll;
        autoScrollOptions = $c416604b0ac15a13$var$assign({}, $c416604b0ac15a13$var$DEFAULTS, $c416604b0ac15a13$var$isObject(autoScroll) ? autoScroll : {});
    }
    function mount() {
        if (!Splide2.is($c416604b0ac15a13$var$FADE)) {
            if (!interval && options.autoScroll !== false) {
                interval = $c416604b0ac15a13$var$RequestInterval(0, move);
                listen();
                autoStart();
            }
        }
    }
    function destroy() {
        if (interval) {
            interval.cancel();
            interval = null;
            currPosition = void 0;
            off([
                $c416604b0ac15a13$var$EVENT_MOVE,
                $c416604b0ac15a13$var$EVENT_DRAG,
                $c416604b0ac15a13$var$EVENT_SCROLL,
                $c416604b0ac15a13$var$EVENT_MOVED,
                $c416604b0ac15a13$var$EVENT_SCROLLED
            ]);
            unbind(root, "mouseenter mouseleave focusin focusout");
            unbind(toggle, "click");
        }
    }
    function listen() {
        if (autoScrollOptions.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (autoScrollOptions.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (autoScrollOptions.useToggleButton) bind(toggle, "click", function() {
            stopped ? play() : pause();
        });
        on($c416604b0ac15a13$var$EVENT_UPDATED, update);
        on([
            $c416604b0ac15a13$var$EVENT_MOVE,
            $c416604b0ac15a13$var$EVENT_DRAG,
            $c416604b0ac15a13$var$EVENT_SCROLL
        ], function() {
            busy = true;
            pause(false);
        });
        on([
            $c416604b0ac15a13$var$EVENT_MOVED,
            $c416604b0ac15a13$var$EVENT_DRAGGED,
            $c416604b0ac15a13$var$EVENT_SCROLLED
        ], function() {
            busy = false;
            autoToggle();
        });
    }
    function update() {
        var autoScroll = options.autoScroll;
        if (autoScroll !== false) {
            autoScrollOptions = $c416604b0ac15a13$var$assign({}, autoScrollOptions, $c416604b0ac15a13$var$isObject(autoScroll) ? autoScroll : {});
            mount();
        } else destroy();
        if (interval && !$c416604b0ac15a13$var$isUndefined(currPosition)) translate(currPosition);
    }
    function autoStart() {
        if (autoScrollOptions.autoStart) {
            if (document.readyState === "complete") play();
            else bind(window, "load", play);
        }
    }
    function play() {
        if (isPaused()) {
            interval.start(true);
            Live.disable(true);
            focused = hovered = stopped = false;
            updateButton();
        }
    }
    function pause() {
        var stop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (!stopped) {
            stopped = stop;
            updateButton();
            if (!isPaused()) {
                interval.pause();
                Live.disable(false);
            }
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused || busy ? pause(false) : play();
    }
    function move() {
        var position = getPosition();
        var destination = computeDestination(position);
        if (position !== destination) {
            translate(destination);
            updateIndex(currPosition = getPosition());
        } else {
            pause(false);
            if (autoScrollOptions.rewind) Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
        }
        throttledUpdateArrows();
    }
    function computeDestination(position) {
        var speed = autoScrollOptions.speed || 1;
        position += orient(speed);
        if (Splide2.is($c416604b0ac15a13$var$SLIDE)) position = $c416604b0ac15a13$var$clamp(position, getLimit(false), getLimit(true));
        return position;
    }
    function updateIndex(position) {
        var length = Splide2.length;
        var index = (toIndex(position) + length) % length;
        if (index !== getIndex()) {
            setIndex(index);
            Components2.Slides.update();
            Components2.Pagination.update();
            options.lazyLoad === "nearby" && Components2.LazyLoad.check();
        }
    }
    function updateButton() {
        if (toggle) {
            var key = stopped ? "startScroll" : "pauseScroll";
            $c416604b0ac15a13$var$toggleClass(toggle, $c416604b0ac15a13$var$CLASS_ACTIVE, !stopped);
            $c416604b0ac15a13$var$setAttribute(toggle, "aria-label", options.i18n[key] || $c416604b0ac15a13$var$I18N[key]);
        }
    }
    function isPaused() {
        return !interval || interval.isPaused();
    }
    return {
        setup: setup,
        mount: mount,
        destroy: destroy,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}

});
parcelRegister("kccop", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eb3e8a8ee265ba96$export$1b5e630bc3aea29f; });

var $dRMjI = parcelRequire("dRMjI");

var $h9x6F = parcelRequire("h9x6F");

var $k1DAy = parcelRequire("k1DAy");

var $2FnmZ = parcelRequire("2FnmZ");
function $eb3e8a8ee265ba96$export$1b5e630bc3aea29f(arr) {
    return (0, $dRMjI._array_without_holes)(arr) || (0, $h9x6F._iterable_to_array)(arr) || (0, $2FnmZ._unsupported_iterable_to_array)(arr) || (0, $k1DAy._non_iterable_spread)();
}

});
parcelRegister("dRMjI", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $a185b452d3e253f6$export$7e0947b5ad3404e2; });

var $8VsSH = parcelRequire("8VsSH");
function $a185b452d3e253f6$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $8VsSH._array_like_to_array)(arr);
}

});
parcelRegister("8VsSH", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $67fa0ccdaa4347f0$export$79e617b1955a2616; });
function $67fa0ccdaa4347f0$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("h9x6F", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $c7ccf52f37db4126$export$1eb58a6e75231000; });
function $c7ccf52f37db4126$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("k1DAy", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $e9429c1bd6fe93fb$export$e6f3c4780d19eb2b; });
function $e9429c1bd6fe93fb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2FnmZ", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $1f1189da1ae074e0$export$a5be06335b3a083c; });

var $8VsSH = parcelRequire("8VsSH");
function $1f1189da1ae074e0$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $8VsSH._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $8VsSH._array_like_to_array)(o, minLen);
}

});


parcelRegister("dvYFb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
function $9d6d3a12581f8329$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



})();
//# sourceMappingURL=splide.7e64a05b.js.map
